<template>
  <section>
    <Toolbar
      v-bind:leyendaProceso="etapaProceso"
      v-bind:esProgresoVisible="true"
    />
    <div class="d-flex flex-column mt-md-5 mt-lg-5 mt-xl-5 mx-6">
      <IconoHeader icono="account" />
      <h3 class="texto-titulo font-weight-bold text-center mt-3">
        Para acceder a este crédito es necesario que te hagas socio
      </h3>
      <p class="text-body text-center mt-5 grey--text text--darken-2">
        Al ser socio contarás con los siguientes beneficios:
      </p>
      <v-card class="mt-0 mx-4 px-4 py-1" elevation="2">
        <v-list dense disabled>
          <v-list-item-group v-model="selectedItem" color="primary">
            <v-list-item v-for="(item, i) in items" :key="i">
              <v-list-item-icon class="mr-1">
                <v-icon v-text="item.icon" color="primary"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
      <v-btn
        class="align-self-center mt-5"
        color="primary"
        elevation="2"
        @click="$router.push('datosPersonales')"
        >¡QUIERO HACERME SOCIO!<v-icon right light
          >mdi-arrow-right</v-icon
        ></v-btn
      >
    </div>
  </section>
</template>

<script>
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
export default {
  components: {
    Toolbar,
    IconoHeader,
  },
  mixins: [InsertaLogMixin],
  name: 'Beneficios',
  props: {
    nombre: {
      type: String,
      default: 'Peter',
    },
    celular: {
      type: String,
      default: '4431713446',
    },
  },
  data: () => ({
    selectedItem: '',
    items: [
      { text: 'Acceso a créditos', icon: 'mdi-circle' },
      { text: 'Cuenta de ahorros e inversión', icon: 'mdi-circle' },
      { text: 'Auxilio en gastos funerarios', icon: 'mdi-circle' },
      { text: 'Seguro de protección de cuentas', icon: 'mdi-circle' },
      { text: 'Banca en línea', icon: 'mdi-circle' },
    ],
    etapaProceso: 'Hazte socio',
  }),
  mounted() {
    this.InsertaLog()
  },
  created() {
    this.$store.getters['persona/obtenerPersona'].tipoPersona != 2
      ? // ? this.$router.push('cargaDocumentos')
        this.$router.push('datosDomicilio')
      : ''
  },
}
</script>
